module.exports = __webpack_public_path__ + "img/cornering_right.2b864647.svg";